/**
 * Роли персон в описании программы
 * @type {String[]}
 */
module.exports = [
    'director',
    'author',
    'producer',
    'actor',
    'presenter',
];
